var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.46 22L.71 13.22a2.45 2.45 0 010-3.45 2.42 2.42 0 013.44 0l6.75 6.79 14.2-15a2.42 2.42 0 013.4-.52c1.08.8 1.3 2.32.51 3.4L13.13 21.73a2.42 2.42 0 01-3.67.27z"
  })));
}

export default SvgCheck;